LRObject.$hooks.register('startProcess', function () {
  jQuery('#fade').show();
  $("#loading-spinner").show();
}
);


LRObject.$hooks.register('endProcess', function (event) {
  var skipEvents = ['login', 'registration', 'setToken']
  if (!skipEvents.includes(event)) {
    $("#loading-spinner").hide();
  }
  jQuery('#fade').hide();
}
);

LRObject.$hooks.register('modifyXhrRequest', function (action, xhr, url) {
  xhr.addEventListener("error", (event) => {
    var eventUrl = event.currentTarget?._url
    var isRegistrationXhrError = (
      eventUrl &&
      eventUrl.startsWith("https://api.loginradius.com/identity/v2/auth/register") &&
      event.type === 'error'
    )
    var isLoginXhrError = (
      eventUrl &&
      eventUrl.startsWith("https://api.loginradius.com/identity/v2/auth/login") &&
      event.type === 'error'
    )
    var shouldStopSpinner = isRegistrationXhrError || isLoginXhrError
    if (shouldStopSpinner) {
      visibleLoadingSpinner(false)
    }
  } ) 
 });

function setErrorMessage(msg) {
  $("#lr-raas-message").css("display", "inline-block");
  jQuery("#lr-raas-message").show().addClass("loginradius-raas-error-message").text(msg);
  visibleLoadingSpinner(false);

}

function setMessage(msg) {
  jQuery("#lr-raas-message").show().addClass("loginradius-raas-success-message").text(msg);
  visibleLoadingSpinner(false);
}

jQuery(window).load(function () {
  jQuery('.lr_fade').hide();   
});

function backtoLogin() {
  var logout_options = {};
  logout_options.onSuccess = function (response) {
    // On Success
    //Write your custom code here
    window.lr_raas_settings.sociallogin = 'false';
    $("#lr-social-traditional-login").show();
    $("#interfacecontainerdiv").show();
    $("#no-email-container").hide();
  };
}

jQuery(".site_login_btn").click(function () {
  // showform('lrLogin')
  jQuery(".account-modal-overlay").show();

  // Manipulate LR Form
  jQuery('.content-loginradius-raas-emailid label').text('Email');

  if (!jQuery('.btn-register').length) {
    var newAccountBtn = '<a class="btn-register" style="float:left;" >New Account</a>';
    jQuery('#login-container form').append(newAccountBtn);
  }

  if (!jQuery('#register-interfacecontainer').length) {
    jQuery('#login-interfacecontainer')
      .clone(true)
      .attr('id', 'register-interfacecontainer')
      .appendTo("#social-registration-interface");
  }
});

jQuery(".account-modal-overlay .close-btn img").click(function () {
  jQuery(".account-modal-overlay").hide();
});


LRObject.util.ready(function () {

  window.lr_raas_settings = window.lr_raas_settings || {};

  if (window.lr_raas_settings.registration) {
    raasoption.preventVerificationEmail = true;
    registration_options.container = window.lr_raas_settings.registration_containerid;
    LRObject.util.ready(function () {
      LRObject.init("registration", registration_options);
    })

  }

  if (window.lr_raas_settings.login) {



    login_options.container = window.lr_raas_settings.login_containerid;
    LRObject.util.ready(function () {
      LRObject.init("login", login_options);
    });



  }

  if (window.lr_raas_settings.forgotpassword) {

    forgotpassword_options.container = window.lr_raas_settings.forgotpassword_containerid;
    LRObject.init("forgotPassword", forgotpassword_options);


  }

  if (window.location.search.indexOf('vtoken') > -1 && window.location.search.indexOf('vtype=reset') > -1) {
    $("#lr-raas-login").hide();
    $("#login-container").hide();
    $("#lr-social-traditional-login").hide();
    $("#resetpassword-container").show();


    if (window.lr_raas_settings.resetpassword) {

      resetpassword_options.container = window.lr_raas_settings.resetpassword_containerid;

      LRObject.init("resetPassword", resetpassword_options);

    }
  }

  if (window.location.search.indexOf('vtoken') > -1 && window.location.search.indexOf('vtype=emailverification') > -1) {


    $("#registration-container").hide();
    $("#lr-raas-message").css("display", "block");
    LRObject.init("verifyEmail", verifyemail_options);

  }


  if (window.lr_raas_settings.sociallogin) {
    raasoption.hashTemplate = true; 
    /* ===== Start Code comment of CustomInterface initialization ===== */ 
    //var custom_interface_option = {}; 
    //custom_interface_option.templateName = 'loginradiuscustom_tmpl'; 
    //LRObject.util.ready(function () { 
    //  LRObject.customInterface(window.lr_raas_settings.sociallogin_interfaceid, custom_interface_option); 
    //});  

    /* ===== End Code comment of CustomInterface initialization ===== */ 

    sl_options.container = window.lr_raas_settings.sociallogin_containerid; 
    LRObject.util.ready(function () { 
      LRObject.init('socialLogin', sl_options); 
    }); 

  }

  LRObject.$hooks.register('socialLoginFormRender', function () {
    //on social login form render
    $("#lr-social-traditional-login").hide();
    $("#interfacecontainerdiv").hide();
    $("#no-email-container").show();
    $("#no-email-container").prepend("<h4> We couldn't find your email address, please fill in the form below </h4>");
    $("#no-email-container").append('    <a onclick="javascript: backtoLogin();" class="backto-login-btn" >Go back to login</a>');
  });

  var maxYear = new Date().getFullYear();
  var minYear = maxYear - 100;
  $('body').on('focus', ".loginradius-raas-birthdate", function () {
    $('.loginradius-raas-birthdate').datepicker({
      dateFormat: 'mm-dd-yy',
      maxDate: new Date(),
      minDate: "-100y",
      changeMonth: true,
      changeYear: true,
      yearRange: (minYear + ":" + maxYear)
    });
  });

  if (getParameterByName("vtype") && getParameterByName("vtype") == "reset" && getParameterByName("vtoken")) {
    jQuery(".account-modal-overlay").show();
    // showform('lrReset');


  }
  if (getParameterByName("vtype") && getParameterByName("vtype") == "emailverification" && getParameterByName("vtoken")) {
    jQuery(".account-modal-overlay").show();
    // showform('lrLogin');
  }

});
function hideMessage() {
  jQuery("#lr-raas-message").hide();
}

function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function exchangeMultipassToken(token, email) {
  return new Promise(function(resolve, reject) {
    var apiUrl = "https://cloud-api.loginradius.com/sso/shopify/api/token?store=" + lrshopifystore;
  
    if (email) {
      fetch(`https://trx-carabiner.herokuapp.com/api/v1/customer?email=${encodeURIComponent(email)}&is_eu=False&query_commercial=True`)
        .then(response => response.json())
        .then(data => {
          var { is_commercial: isCommercial, is_elite: isElite, is_retail: isRetail } = data;
  
          console.log({ isCommercial, isElite, isRetail });
  
          if (isCommercial) {
            apiUrl += "&return_url=%2Fpages%2Fcommercial-solutions";
          } else if (isElite) {
            apiUrl += "&return_url=%2Fpages%2Ftrx-elite-military";
          } else if (isRetail) {
            apiUrl += "&return_url=%2Fpages%2Fretail-solutions";
          } else if (getParameterByName("checkout_url")) {
            var checkoutUrlObject = new URL(getParameterByName("checkout_url"));
            var returnPath = checkoutUrlObject.toString().substring(checkoutUrlObject.origin.length);
            apiUrl += "&return_url=" + returnPath;
          }
  
          fetch(apiUrl, {
            headers: {
              'Authorization': 'Bearer ' + token,
              'X-LoginRadius-ApiKey': raasoption.apiKey
            },
            method: 'GET'
          })
          .then(response => response.json())
          .then(data => {
            console.log({ data });
            resolve(data);
          })
          .catch(error => {
            console.error("Token exchange error:", error);
            reject(error);
          });
        })
        .catch(error => {
          console.error("Fetch customer error:", error);
          reject(error);
        });
    } else {
      if (getParameterByName("checkout_url")) {
        var checkoutUrlObject = new URL(getParameterByName("checkout_url"));
        var returnPath = checkoutUrlObject.toString().substring(checkoutUrlObject.origin.length);
        apiUrl += "&return_url=" + returnPath;
      }
  
      fetch(apiUrl, {
        headers: {
          'Authorization': 'Bearer ' + token,
          'X-LoginRadius-ApiKey': raasoption.apiKey
        },
        method: 'GET'
      })
      .then(response => response.json())
      .then(data => {
        console.log({ data });
        resolve(data);
      })
      .catch(error => {
        console.error("Token exchange error:", error);
        reject(error);
      });
    }
  });
  }



//Login
var login_options = {};
login_options.onSuccess = function(response) {
  var email;
  try {
    email = response.Profile.Email.find(el => el.Type === 'Primary').Value;
  } catch (e) {
    console.log("login_options.onSuccess", { e });
  }
  
  visibleLoadingSpinner(true); // Show spinner during token exchange

  exchangeMultipassToken(response.access_token, email)
    .then(data => {
      console.log({ data });
      window.location = data.url; // Redirect to the profile page
    })
    .catch(error => {
      console.error("Token exchange error:", error);
      setErrorMessage("An error occurred during login. Please try again.");
      visibleLoadingSpinner(false); // Hide spinner on error
    });
};

login_options.onError = function (errors) {
  //On Errors
    setErrorMessage(errors[0].Message);
  console.log(errors);
};

// Logout Action
var logout_options = {};
logout_options.onSuccess = function (response) {
  // On Success
  //Write your custom code here
  console.log("Session not found");
  window.location = window.Shopify.routes.root + 'account/logout';
};


var forgotpassword_options = {};

forgotpassword_options.onSuccess = function (response) {
  // On Success
   
   if(response.IsPosted == true && typeof response.Data !== 'undefined' && response.Data!==null)
            {
                setMessage("OTP has been sent to your phone number.");                  
            }else if(LRObject.options.otpEmailVerification==true && typeof response.Data==='undefined')
            {
                setMessage("OTP has been sent to your email address.");              
            } else if (response.IsPosted == true && typeof (response.Data) === "object") {				
                if(jQuery('form[name="loginradius-resetpassword"]').length > 0) {
                  setMessage("Password has been reset successfully.");  
                    $("#lr-raas-login").show();
                    $("#login-container").show();
                    $("#lr-social-traditional-login").show();
                    $("#lr-raas-forgotpassword").hide();
                }           
            }else if (response.IsPosted == true && typeof (response.Data) === "undefined") {
                if(jQuery('form[name="loginradius-resetpassword"]').length > 0) {                    
                  setMessage("Password has been reset successfully.");  
                   $("#lr-raas-login").show();
                    $("#login-container").show();
                    $("#lr-social-traditional-login").show();
                    $("#lr-raas-forgotpassword").hide();
                } else {
                  setMessage("Password reset information sent to your provided email id, check email for further instructions");
                   
                }
            }
 
};
forgotpassword_options.onError = function (errors) {
  // On Errors
  
        if (errors[0].Description != null) {
                setErrorMessage(errors[0].Description);
            } else if (errors[0] != null) {
                setErrorMessage(errors[0].Message);
            }
}


var verifyemail_options = {};
verifyemail_options.onSuccess = function (response) {
  // On Success
  $("#lr-social-traditional-login").hide();
  $("#interfacecontainerdiv").hide();
  $("#no-email-container").show();
  $("#no-email-container h4").hide();

  console.log(response);
  setMessage("Email verified, now you can login");
};
verifyemail_options.onError = function (errors) {
  // On Errors
  $("#lr-social-traditional-login").hide();
  $("#interfacecontainerdiv").hide();
  $("#redirectologin").show();
  console.log(errors);
  setErrorMessage(errors[0].Message);
}

var resetpassword_options = {};

resetpassword_options.onSuccess = function (response) {
  // On Success

  document.getElementsByName("loginradius-resetpassword")[0].reset();
  console.log(response);
  setMessage("Password reset successfully, now you can login");
  $("#lr-raas-login").show();
  $("#lr-social-traditional-login").show();
  $("#lr-raas-forgotpassword").hide();
  $('#login-page-header').show();
  $('#resetpw-page-header').hide();
  $("#setpw-page-header").hide();
  $("#lr-raas-back-to-login").hide();
  $("#login-container").show();
  $("#resetpassword-container").hide();
};
resetpassword_options.onError = function (errors) {
  // On Errors
  console.log(errors);
    if (errors[0].Description != null) {
        setErrorMessage(errors[0].Description);
    } else if (errors[0] != null) {
        setErrorMessage(errors[0].Message);
    }
}


var registration_options = {}
registration_options.onSuccess = function(response) {
	console.log(response);
    var email;
  try {
    email = response.Profile.Email.find(el => el.Type === 'Primary').Value;
  } catch (e) {
    console.log("registration_options.onSuccess", { e });
  }
	var optionalemailverification = "",
		disableemailverification = "";
	typeof LRObject.options.optionalEmailVerification < "u" && (optionalemailverification = LRObject.options.optionalEmailVerification), typeof LRObject.options.disabledEmailVerification < "u" && (disableemailverification = LRObject.options.disabledEmailVerification), response.IsPosted && response.Data == null ? (typeof optionalemailverification > "u" || optionalemailverification !== !0) && (typeof disableemailverification > "u" || disableemailverification !== !0) && setMessage("Email for verification has been sent to your provided email, please check email for further instructions") : response.access_token != null && response.access_token != "" ? exchangeMultipassToken(response.access_token, email).then(data => { console.log({ data }); console.log("Shopify =" + data.url); window.location = "https://trxtraining.hub.loginradius.com/ssologin/setSafariToken?token=" + response.access_token + "&callback=" + data.url; }).catch(error => { console.error("Token exchange error:", error); setErrorMessage("An error occurred during login. Please try again."); visibleLoadingSpinner(false); }) : response.IsPosted && typeof response.Data < "u" && response.Data !== null && typeof response.Data.Sid < "u" ? setMessage("OTP has been sent to your phone number.") : LRObject.options.otpEmailVerification == !0 && response.Data == null ? setMessage("OTP has been sent to your email address.") : setMessage("Email for verification has been sent to your provided email, please check email for further instructions")
}, registration_options.onError = function(errors) {
	console.log(errors), setErrorMessage(errors[0].Message)
};
var sl_options = {};
sl_options.onSuccess = function (response) {
  //On Success
  //Here you get the access token
  console.log(response);
  if (response.IsPosted) {
    //document.getElementsByName("loginradius-socialRegistration")[0].reset();
    setMessage("Email for verification has been sent to your provided email, please check email for further instructions");
    jQuery('#interfacecontainerdiv').hide();
  } else {
    exchangeMultipassToken(response.access_token);    
  }
};
sl_options.onError = function (errors) {
  //On Errors
  if (window.isSSORedirectedToken) {
    LRObject.init("logout", logout_options);

  }
  else {
    setErrorMessage(errors[0].Message);
  }
};




//Account Linking
var la_options = {};
la_options.container = "interfacecontainerdiv";
la_options.templateName = 'loginradiuscustom_tmpl_link';
la_options.onSuccess = function (response) {
  // On Success
  console.log(response);
};
la_options.onError = function (errors) {
  // On Errors
  console.log(errors);
}



function lrLogout() {
  LRObject.init("logout", logout_options);
  console.log("logout");
};

function getParameterByName(name) {
  var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

$(document).ready(function () {
  var pathname = window.location.pathname;

  if (pathname == window.Shopify.routes.root + "logout/account") {
    console.log("on the page");
    LRObject.init("logout", logout_options);
    console.log("logout");
  }

  var isLoginOrRegisterPage = (
    pathname === window.Shopify.routes.root + 'account/login' ||
    pathname === window.Shopify.routes.root + 'account/register'
  )

  var checkoutUrlQueryParam = getParameterByName('checkout_url');
  var hasCheckoutUrlQueryParam = !!checkoutUrlQueryParam;

  if (isLoginOrRegisterPage && hasCheckoutUrlQueryParam) {
    $('a[href]#lr-raas-login-link,a[href]#lr-raas-user-register').each(function () {
      var $elem = $(this);
      var href = $elem.attr('href');
      var newHref = href + (href.indexOf('?') != -1 ? '&' : '?') + 'checkout_url=' + checkoutUrlQueryParam
      $elem.attr('href', newHref);
      $elem.on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = newHref;
      });
    });
  }
});



function visibleLoadingSpinner(isvisible) {
  if (isvisible) {
    $("#loading-spinner").show();
  }
  else {
    $("#loading-spinner").hide();
  }
};
